import { createGlobalStyle } from 'styled-components';
import backgroundPattern from '../assets/bg-pattern.jpg'

export default createGlobalStyle`
      *{
        margin:0;
        padding: 0;
        outline: 0;
        box-sizing: border-box;
      }
      body{

        background: url(${backgroundPattern}) #fff;
        overflow-x: hidden;

        color:#545454;
       -webkit-font-smoothing: antialiased ;

        width: 100%;
        height: 100vh;



      }
      body, input, button{
        font-family: 'Roboto', sans-serif;;
        font-size: 16px;
      }
      button{
        cursor: pointer;
      }
      `;
